import React from 'react';
import axios from 'axios';
import { addDatadogFeatureFlagEvaluation, Host as MfeHost, HostConfigurationResponse, HostProps } from '@economic/react-app';
import { AppDrawerProvider } from '~/app/components/AppDrawer/AppDrawerContext';
import getEnvironment from '~/utilities/getEnvironment';
import getEnvironmentType from '~/utilities/getEnvironmentType';
import tracer from '~/utilities/trace';
import emitEvent from '~/utilities/snowplow/emitEvent';
import Application from '~/components/Application';
import { LegacyFrameIntegration } from '~/app/shared/components/LegacyFrameIntegration';
import { INTERNAL_API_URL } from '~/app/shared/util/api/internalApiClient';
import { DATADOG_CONFIG } from '~/constants/datadog';

const fetchConfiguration = async () => {
    const host = await axios.get<HostConfigurationResponse>(`${INTERNAL_API_URL}/mfe/host`).then(response => response.data);

    return host;
};

const Host = () => {
    const configuration = {
        datadog: DATADOG_CONFIG,
        fetcher: fetchConfiguration,
        firebaseEmulator: {
            authHost: process.env.FIREBASE_AUTH_EMULATOR_HOST ?? '',
            host: process.env.FIRESTORE_EMULATOR_HOST ?? '',
        },
    } satisfies HostProps['configuration'];

    return (
        <AppDrawerProvider>
            <MfeHost
                configuration={configuration}
                environment={getEnvironment()}
                environmentType={getEnvironmentType()}
                origin={process.env.PUBLIC_URL}
                version={process.env.CLIENT_VERSION ?? 'development'}
                onFlagExposed={(name, value) => {
                    tracer.info(`feature:${name} ${value}`);
                    emitEvent('iglu:com.e-conomic/experiment_started/jsonschema/1-0-2', {
                        experimentName: name,
                        experimentVariant: value,
                    });
                    addDatadogFeatureFlagEvaluation(name, value);
                }}>
                <Application />
                <LegacyFrameIntegration path={process.env.ECONOMIC_PATH ?? ''} />
            </MfeHost>
        </AppDrawerProvider>
    );
};

export default Host;
